export const CURRENT_TERMS_VERSION = '1.0';
export const CURRENT_PRIVACY_VERSION = '1.0';

export const hasAcceptedCurrentLegalDocuments = (consent = {}) =>
  Boolean(consent.termsAcceptedAt) &&
  Boolean(consent.privacyAcceptedAt) &&
  consent.termsVersion === CURRENT_TERMS_VERSION &&
  consent.privacyVersion === CURRENT_PRIVACY_VERSION;
